import { SearchResultItem } from '../api';

function money(amount?: number | null, currency?: string | null): string | null {
  if (amount == null) return null;
  const code = currency ?? '';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code || 'USD',
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    // An unrecognised currency code throws rather than falling back, and a demo
    // must not blank a result over a formatting nicety.
    return `${code} ${amount.toLocaleString()}`.trim();
  }
}

export default function ResultCard({ item }: { item: SearchResultItem }) {
  const f = item.fields ?? {};
  const price = money(f.price, f.currency);
  const parts = [
    f.bedrooms != null ? `${f.bedrooms} bed` : null,
    f.bathrooms != null ? `${f.bathrooms} bath` : null,
    [f.area_name, f.city].filter(Boolean).join(', ') || null,
  ].filter(Boolean);

  return (
    <article className="result">
      <header>
        <h4>{f.title || item.doc_id}</h4>
        {price && <span className="price">{price}</span>}
      </header>

      <p className="meta">
        {parts.join(' · ')}
        {parts.length > 0 && ' · '}
        <span className="docid">{item.doc_id}</span>
      </p>

      {/* The evidence, not just the ranking. A portal integrating this needs to
          show a renter WHY a listing came back, and these are the strings for it. */}
      {item.matchReasons?.length > 0 && (
        <div className="chips">
          {item.matchReasons.map((reason, i) => (
            <span key={`${reason.label}-${i}`} className={`chip ${reason.kind}`}>
              {reason.label}
            </span>
          ))}
        </div>
      )}

      {item.commute && (
        <p className="commute">
          <strong>{item.commute.estimateMin} min</strong> by {item.commute.mode} (
          {item.commute.rangeMin[0]}–{item.commute.rangeMin[1]} min,{' '}
          {item.commute.confidence} confidence)
          {item.commute.withinBudget ? ' — within budget' : ' — over budget'}
        </p>
      )}

      <p className="footnote score">score {item.score.toFixed(3)}</p>
    </article>
  );
}
